export default __webpack_public_path__ + "static/media/condomobLogo.ce040d5c.svg";